/* Match my bike - a note that rides along with the build.
   ==========================================================================
   THE IDEA
   Most people configuring this already own the real thing. The configurator
   can reproduce their actual bike part for part, which is a reason to buy
   that no stock photo competes with - but nothing on the page ever invited
   them to say "make it like mine". This does.

   The note is attached to the BIKE's cart line as a visible property, so it
   travels into the order and is sitting there in admin when the build is
   picked up. Nobody has to copy anything between an email and an order.

   WHY TEXT AND NOT A PHOTO UPLOAD
   Shopify can attach an uploaded file to a line item, but only through a real
   multipart form POST to /cart/add. This builder adds the bike and all its
   paid upgrades in a single /cart/add.js call, and that is also where
   cart-builds.js stamps the shared build id that keeps a bike and its parts
   together. Converting it to a form post to carry a file would break both.

   So: text now, which is reliable and covers most of it ("gold forks, black
   plate, number 72"), plus a clear line telling them how to send a photo
   against their order number. A real upload is possible but means
   restructuring add-to-cart, which is not worth risking for this.

   The value is read by cart-builds.js at add time via window.__pmMatch.
   ========================================================================== */
(function builderMatch() {
  var MAX = 300;
  var STORE_KEY = 'pm-match-v1:' + location.pathname;

  var value = '';

  function load() {
    try {
      return window.sessionStorage.getItem(STORE_KEY) || '';
    } catch (e) {
      return '';
    }
  }

  function save(v) {
    try {
      if (v) window.sessionStorage.setItem(STORE_KEY, v);
      else window.sessionStorage.removeItem(STORE_KEY);
    } catch (e) { /* private mode - the note still works for this page view */ }
  }

  function mount() {
    if (document.querySelector('.pm-match')) return;

    var addcart = document.querySelector('#pm-3d .pm-addcart');
    if (!addcart) return;

    value = load();

    var wrap = document.createElement('div');
    wrap.className = 'pm-match';

    var label = document.createElement('label');
    label.className = 'pm-match__label';
    label.setAttribute('for', 'pm-match-note');
    label.textContent = 'Match your bike';

    var help = document.createElement('p');
    help.className = 'pm-match__help';
    help.textContent =
      'Own the real thing? Tell us what to match - mods, colours, plate number - and we will build yours to suit.';

    var ta = document.createElement('textarea');
    ta.className = 'pm-match__input';
    ta.id = 'pm-match-note';
    ta.rows = 3;
    ta.maxLength = MAX;
    ta.placeholder = 'e.g. gold forks, black ODI grips, number 72 on the plate';
    ta.value = value;

    var foot = document.createElement('p');
    foot.className = 'pm-match__foot';

    var count = document.createElement('span');
    count.className = 'pm-match__count';

    var photo = document.createElement('span');
    photo.className = 'pm-match__photo';
    photo.textContent = 'Got a photo? Reply to your order confirmation and we will work from it.';

    function sync() {
      count.textContent = ta.value.length + '/' + MAX;
      count.classList.toggle('is-full', ta.value.length >= MAX);
    }

    ta.addEventListener('input', function () {
      value = ta.value;
      save(value);
      sync();
    });

    sync();

    foot.appendChild(count);
    foot.appendChild(photo);

    wrap.appendChild(label);
    wrap.appendChild(help);
    wrap.appendChild(ta);
    wrap.appendChild(foot);

    /* Above Add to cart: it is part of specifying the build, not an
       afterthought once they have decided. */
    addcart.parentNode.insertBefore(wrap, addcart);
  }

  /* The options panel is built by the section after three.js resolves, so the
     Add to cart button is not there at DOMContentLoaded. Same wait the other
     injected controls use. Gives up after ~30s. */
  function waitForBuilder() {
    var tries = 0;
    var poll = window.setInterval(function () {
      tries++;
      if (document.querySelector('#pm-3d .pm-addcart')) {
        window.clearInterval(poll);
        mount();
      } else if (tries > 150) {
        window.clearInterval(poll);
      }
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForBuilder);
  } else {
    waitForBuilder();
  }

  /* Read by cart-builds.js when it stamps the add payload. Reads the live
     field rather than the cached copy, so a note typed and not blurred still
     makes it into the order. */
  window.__pmMatch = {
    note: function () {
      var el = document.getElementById('pm-match-note');
      var v = el ? el.value : value;
      return (v || '').trim().slice(0, MAX);
    },
    clear: function () {
      var el = document.getElementById('pm-match-note');
      if (el) el.value = '';
      value = '';
      save('');
    },
  };
})();